module.exports = __webpack_public_path__ + "img/RBS_event_03_loading.e621991b.jpg";